<template>
  <div class="events-container">
    <EventMonthContainer v-if="listViewType === 'month'" />
    <EventAllContainer v-else />
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, onMounted } from 'vue';
import isEmpty from 'lodash/isEmpty';
import { useEventsStore } from '../../../../stores/eventsStore.js';

defineOptions({
  name: 'EventsListView',
});

const EventAllContainer = defineAsyncComponent(() => import('./List/EventAllContainer.vue'));
const EventMonthContainer = defineAsyncComponent(() => import('./List/EventMonthContainer.vue'));

const eventsStore = useEventsStore();

const listViewType = computed(() => eventsStore.listViewType);
const sections = computed(() => eventsStore.sections);
const selectedCalendars = computed(() => eventsStore.selectedCalendars);

onMounted(() => {
  if (isEmpty(selectedCalendars.value)) {
    eventsStore.initSelectedCalendars(sections.value.flatMap((item) => item.id));
  }
});
</script>
